// immediate improvements (will apply to new features and api migration)
// - separate store files per service/controller?
// - reduce repeated large codes
// - maximize of enums use
// - taking advantage of async await
// - set 'src' as base url with alias @ for for better definition of paths

// others:
// - shared docs for old API endpoint paired with New Endpoint API for migration
// - remove debugger script before deployment, replace with centralized console log appears when error only
// - reduce warnings on logs
// - remove unused script
import { Post, Get, Put, Delete } from "@/utils";
import { ApiPath, UserRoles } from "@/enums";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async getCareerDetails({}, onetcode) {
      const { data: skillsPassportDetails } = await Get(
        `${ApiPath.SkillsPassport}/getskillspassportdetails?onetcode=${onetcode}`
      );
      return skillsPassportDetails;
    },
    async saveSkillsPassport({}, body) {
      const { data: skillsPassportDetails } = await Post(
        `${ApiPath.SkillsPassport}/saveskillspassportdetails`,
        body
      );
      return skillsPassportDetails;
    },
    async getSkillsPassportSummary({}) {
      const { data: skillsPassportSummary } = await Get(
        `${ApiPath.SkillsPassport}/getskillspassportsummary`
      );
      return skillsPassportSummary;
    },
    async deleteSkillsPassport({}, onetcode) {
      const { data: skillsPassportSummary } = await Delete(
        `${ApiPath.SkillsPassport}/removeskillspassportdetails?onetcode=${onetcode}`
      );
      return skillsPassportSummary;
    },
    async checkSkillsPassport({}, onetcode) {
      const { data: skillsPassportDetails } = await Get(
        `${ApiPath.SkillsPassport}/verifyskillspassportdetails?onetcode=${onetcode}`
      );
      return skillsPassportDetails;
    }
  }
};
